import { faSparkles, faTimes } from '@fortawesome/pro-light-svg-icons';
import { useState } from 'react';
import { Button, IconBox, Link } from '~/common/components';
import { cx } from '~/common/utils';
import { routes } from '~/constants';
import { useInitData } from '~/root/Auth';
import { MEDLY_BANNER_LS_KEY, MEDLY_SSO_URL, medlyGradientClassName } from './constants';

export const MedlyBanner = ({ className }: { className?: string }) => {
  const { canUseMedly } = useInitData();
  const [open, setOpen] = useState(() => !localStorage.getItem(MEDLY_BANNER_LS_KEY));

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(MEDLY_BANNER_LS_KEY, 'true');
  };

  if (!canUseMedly || !open) return null;

  return (
    <div className={cx('flex items-start gap-1 p-2 rounded-md', medlyGradientClassName, className)}>
      <IconBox size="m" icon={faSparkles} className="text-info-300" />

      <div className="flex-1 min-w-0 flex flex-col gap-[12px]">
        <div className="flex flex-col gap-1">
          <p className="font-brand-l2 text-text-500">You’re invited to the Medly pilot</p>
          <p className="font-brand-b3 text-text-400">
            Be the first to try our AI deck builder. It drafts slides in your brand, with a 24Slides
            designer one click away.{' '}
            <Link.Base
              href={routes.public.medly}
              newTab
              className="font-medium text-text-600 underline hover:text-primary-400 transition-colors"
            >
              What is Medly?
            </Link.Base>
          </p>
        </div>

        <Link.Button color="outlined-navy" size="s" className="w-fit" href={MEDLY_SSO_URL} newTab>
          Open Medly
        </Link.Button>
      </div>

      <Button.Icon
        size="m"
        icon={faTimes}
        aria-label="Close"
        className="text-text-500"
        onClick={handleClose}
      />
    </div>
  );
};
